import ArrowClockwise from '../../src/legacy/ArrowClockwise';
export default ArrowClockwise;
